import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarMembresiasConfiguracion } from '../../../actions/configuracion';

import { formatNumber } from '../../../utils/generalFunctions';

import NuevaMembresia from './NuevaMembresia';
import EditarMembresia from './EditarMembresia';
import EliminarMembresia from './EliminarMembresia';

const Membresias = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Membresias',
            path: '/configuracion/membresias'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.membresias);

    const [membresias, setMembresias] = useState([]);

    const [membresiaAgregar, setMembresiaAgregar] = useState(null);
    const [membresiaEditar, setMembresiaEditar] = useState(null);
    const [membresiaEliminar, setMembresiaEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => row.nombre,
        }, 
        {
            name: 'Precio',
            selector: row => formatNumber(row.precio, 2, '$ ', '')
        },
        {
            name: 'Beneficios',
            sortable: true, 
            selector: row => row.beneficios.length,
        },
        {
            name: 'Descripción',
            selector: row => row.descripcion,
            grow: 3, 
            wrap: true
        },
        {
            name: '',
            cell: row => {
                if(row._id){
                    return(
                        <div className="text-right w-100">
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarMembresia(row)}><i className="fas fa-trash text-danger"></i></button>
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarMembresia(row)}><i className="fas fa-edit text-warning"></i></button>
                        </div>
                    )
                }else{
                    return(<></>)
                }
            }
        }
    ];

    /* Crear membresia */
    const handleAgregarMembresia = (membresia) => {
        setMembresiaEditar(null);
        setMembresiaEliminar(null);

        setMembresiaAgregar(membresia);        
    }

    /* Editar membresia */
    const handleEditarMembresia = (membresia) => {
        setMembresiaAgregar(null);
        setMembresiaEliminar(null);

        setMembresiaEditar(membresia);
    }

    /* Eliminar membresia */
    const handleEliminarMembresia = (membresia) => {
        setMembresiaAgregar(null);
        setMembresiaEditar(null);

        setMembresiaEliminar(membresia);
    }

    /* Funciones generales */
    const horariosToText = (horarios) => {
        let horarios_formateados = [];

        for (let i = 0; i < horarios.length; i++) {
            horarios_formateados.push(horarios[i].hora_inicio + ' - ' + horarios[i].hora_fin);
        }

        return horarios_formateados.join(', ');
    }

    useEffect(() => {
        dispatch(buscarMembresiasConfiguracion());
    }, []);

    useEffect(() => {
        setMembresias(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <NuevaMembresia membresia={membresiaAgregar} reestablecerMembresia={handleAgregarMembresia} />
            <EditarMembresia membresia={membresiaEditar} reestablecerMembresia={handleEditarMembresia} />
            <EliminarMembresia membresia={membresiaEliminar} reestablecerMembresia={handleEliminarMembresia} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Membresias</h3>

                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn btn-primary" onClick={() => handleAgregarMembresia({ })}>Agregar membresia</button>
                    </div>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={membresias}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Membresias;